const CONNECTORS = [
  'de',
  'di',
  'do',
  'da',
  'dos',
  'das',
  'dello',
  'della',
  'dalla',
  'dal',
  'del',
  'e',
  'em',
  'na',
  'no',
  'nas',
  'nos',
  'van',
  'von',
  'y',
  '-',
  ','
]

export const truncateName = (name = '', length?: number): string => {
  if (!name) return ''
  const nameArray = name.trim().split(' ')
  let truncatedName = nameArray[0]

  for (let i = 1; i < nameArray.length; i++) {
    const tempTruncatedName = [truncatedName, nameArray[i]].join(' ')

    if (length === undefined || tempTruncatedName.length <= length) {
      truncatedName = tempTruncatedName
    } else {
      break
    }
  }

  CONNECTORS.forEach(
    connector =>
      (truncatedName = truncatedName.replace(
        new RegExp(` ${connector}$`, 'g'),
        ''
      ))
  )

  return truncatedName.trim()
}
